import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from './exclusive-seller-product-table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.object
}

const defaultProps = {
  hiddenColumns  : [],
  isLoading      : false,
  rowButtonProps : {
    onButtonClick : () => {},
    buttonText    : 'Action',
    buttonColour  : 'primary'
  }
}

/**
 * Table to display Exclusive Seller Products columns
 * @param {Array<Object>} data - array of exclusive seller product objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const CustomerRefundTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  isLoading,
  rowButtonProps
}) => {
  const {
    onButtonClick,
    buttonText,
    buttonColour
  } = rowButtonProps

  const columns = useMemo(() => tableColumns({
    onButtonClick,
    buttonText,
    buttonColour
  }), [
    onButtonClick,
    buttonText,
    buttonColour
  ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

CustomerRefundTable.propTypes    = propTypes
CustomerRefundTable.defaultProps = defaultProps

export default CustomerRefundTable
